/** Adapts React Router's <Link> to the shared components' `as` link prop. */
import type { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

export function RouterLink({ to, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & { to: string }) {
  return <Link to={to} {...rest} />;
}
